export enum RedirectContext {
    ENTRY = 'ENTRY',
}
